import { render, staticRenderFns } from "./wasiat-asas-receipt.vue?vue&type=template&id=500547e8&"
import script from "./wasiat-asas-receipt.vue?vue&type=script&lang=js&"
export * from "./wasiat-asas-receipt.vue?vue&type=script&lang=js&"
import style0 from "./wasiat-asas-receipt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports